import type { ReportType } from "@/lib/report-tree"

/**
 * Display-only rules for the Report Library tree. Keys are the original folder path with the
 * report-type prefix stripped and segments joined by "." (e.g. "Fabrication.Assembly").
 * Nothing here affects report data or behavior — only what the user sees in the tree.
 */
export interface ReportTreeDisplayRules {
  /** Folders to remove from the tree; their children move up into the parent's position. */
  promote?: string[]
  /** Folder path -> replacement label. Keys always use the original (pre-promotion) path. */
  rename?: Record<string, string>
}

export const REPORT_TREE_DISPLAY_CONFIG: Record<ReportType, ReportTreeDisplayRules> = {
  project: {
    promote: ["Fabrication", "Pricing"],
    rename: {
      "Pricing.Internal": "Internal Pricing",
      "Pricing.Customer": "Customer Pricing",
      "Fabrication.CoverSheets": "Cover Sheets",
    },
  },
  administrative: {},
  custom: {},
}
